import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, CheckCircle, Home } from 'lucide-react';

const TestCompletionPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-indigo-500 text-white">
      <header className="container mx-auto py-6 px-4">
        <div 
          className="flex items-center space-x-2 cursor-pointer hover:opacity-80 transition-opacity"
          onClick={() => navigate('/')}
        >
          <Brain className="h-8 w-8" />
          <span className="text-2xl font-bold">PMind</span>
        </div>
      </header>

      <div className="container mx-auto px-4 py-20">
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-white/10 backdrop-blur-lg rounded-xl p-8">
            <div className="mb-8">
              <CheckCircle className="h-20 w-20 text-green-400 mx-auto" />
            </div>
            <h1 className="text-4xl font-bold mb-4">Test Finalizat!</h1>
            <p className="text-xl mb-8">
            Îți mulțumim pentru completarea testului. Rezultatele tale vor fi trimise pe email conform instrucțiunilor profesorului.
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-yellow-400 hover:bg-yellow-300 text-purple-900 font-bold py-3 px-8 rounded-lg flex items-center mx-auto transition transform hover:scale-105"
            >
              <Home className="h-5 w-5 mr-2" />
              Înapoi Acasă
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestCompletionPage;
